import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import { catchError } from '../../helpers/catch-error-client'


const CreateWorkOrder = ({ work_order }) => {

    const [isBtn, setIsBtn] = useState(false);
    const navigate = useNavigate();
    const saveWorkOrder = async (e) => {


        if (!work_order?.patient_id || !work_order?.facility_id || !work_order?.client_id || !work_order?.wo_request_submitted_by) {

            Swal.fire({ icon: "error", title: "Work Order Info", text: "Please enter patient, facility, work order and client information." });

        } else {

            setIsBtn(true);
            axios.post(process.env.REACT_APP_WEB_SERVICES_URL + "/client/create-work-order", { work_order_id: work_order?.work_order_id }, {
                headers: {
                    'Content-Type': 'application/json'
                },
                withCredentials: true
            }).then(async function (response) {

                if (response?.data?.status && work_order.authorization_status == 1) {

                    navigate("/client/home")


                } else if (response?.data?.status) {
                    Swal.fire({
                        icon: "warning",
                        title: "Your case has been  submitted!",
                        text: "Case has been submitted successfully. Please upload patient authorization.",
                    });
                    
                }
                else {

                    Swal.fire({ icon: "error", title: "Note Info", text: response?.data?.message });

                }
                setIsBtn(false)

            }).catch(function (error) {


                setIsBtn(false);
                catchError(error, navigate)


            });

        }


    }


    return (


        <div className="card card-form  mb-5 " >
            <div className="card-body p-0" >
                <div className="row m-0" >


                    <div className="col-12 text-center">

                        <button onClick={() => { saveWorkOrder(); }} className="btn btn-xl  btn-primary " type="button" disabled={isBtn} > {isBtn ? <><div className="spinner-border spinner-border-sm me-1" role="status"></div><span className="sr-only">Loading...</span></> : 'Save Work Order'}</button>


                    </div>


                </div>

            </div>


        </div>



    )

}
export default CreateWorkOrder;